export const paymentTypeDictionary: Record<string, string> = {
    'credit_card': "Crédito",
    'pix': "Pix",
};

export enum WalletOrder {
    SPOTT_CREDIT = "SPOTT_CREDIT",
    // Transferência de saldo entre carteiras: um lado sai da origem, o outro entra no destino.
    SPOTT_TRANSFER_OUT = "SPOTT_TRANSFER_OUT",
    SPOTT_TRANSFER_IN = "SPOTT_TRANSFER_IN",
}